import { ROW_HEIGHT, TABLE_OVERSCAN } from 'Modules/Spaces/show/constants';
import * as GrooveLocalStorage from 'GrooveLocalStorage';

const overscan =
  GrooveLocalStorage.fetch('spacesScrollOverscanCount') || TABLE_OVERSCAN;

export const calculateStartIndex = scrollTop => {
  const calculatedStart = Math.floor(scrollTop / ROW_HEIGHT) - overscan;
  return Math.max(calculatedStart, 0);
};

export const calculateStopIndex = (scrollTop, offsetHeight, rowCount) => {
  const calculatedStop =
    Math.floor((scrollTop + offsetHeight) / ROW_HEIGHT) + overscan;
  const lastIndex = rowCount - 1;
  return Math.min(calculatedStop, lastIndex);
};

export const calculateTopOffset = renderStartIndex =>
  renderStartIndex * ROW_HEIGHT;

export const calculateBottomOffset = (stopIndex, rowCount) => {
  const lastIndex = rowCount - 1;
  const unrenderedSize = lastIndex - stopIndex;
  return unrenderedSize * ROW_HEIGHT;
};
